import type { InvoiceRevenue } from "@warrenio/api-spec/spec.oats.gen";

export const adminInvoiceTotalsExample: InvoiceRevenue[] = [
    {
        period_start_month: 1735689600,
        document_type: "credit_note",
        total_before_tax: 31.79,
        vat_tax: 6.4,
    },
    {
        period_start_month: 1738368000,
        document_type: "credit_note",
        total_before_tax: 0.0,
        vat_tax: 0.0,
    },
    {
        period_start_month: 1740787200,
        document_type: "credit_note",
        total_before_tax: 0.0,
        vat_tax: 0.0,
    },
    {
        period_start_month: 1743465600,
        document_type: "credit_note",
        total_before_tax: 0.0,
        vat_tax: 0.0,
    },
    {
        period_start_month: 1746057600,
        document_type: "credit_note",
        total_before_tax: 98.35,
        vat_tax: 19.67,
    },
    {
        period_start_month: 1748736000,
        document_type: "credit_note",
        total_before_tax: 0.0,
        vat_tax: 0.0,
    },
    {
        period_start_month: 1751328000,
        document_type: "credit_note",
        total_before_tax: 0.0,
        vat_tax: 0.0,
    },
    {
        period_start_month: 1754006400,
        document_type: "credit_note",
        total_before_tax: 0.0,
        vat_tax: 0.0,
    },
    {
        period_start_month: 1756684800,
        document_type: "credit_note",
        total_before_tax: 0.0,
        vat_tax: 0.0,
    },
    {
        period_start_month: 1759276800,
        document_type: "credit_note",
        total_before_tax: 0.0,
        vat_tax: 0.0,
    },
    {
        period_start_month: 1761955200,
        document_type: "credit_note",
        total_before_tax: 1724.31,
        vat_tax: 120.66,
    },
    {
        period_start_month: 1764547200,
        document_type: "credit_note",
        total_before_tax: 0.06,
        vat_tax: 0.01,
    },
    {
        period_start_month: 1735689600,
        document_type: "invoice",
        total_before_tax: 8470.67,
        vat_tax: 1613.44,
    },
    {
        period_start_month: 1738368000,
        document_type: "invoice",
        total_before_tax: 10225.49,
        vat_tax: 1990.34,
    },
    {
        period_start_month: 1740787200,
        document_type: "invoice",
        total_before_tax: 8079.18,
        vat_tax: 1545.45,
    },
    {
        period_start_month: 1743465600,
        document_type: "invoice",
        total_before_tax: 7105.69,
        vat_tax: 1378.76,
    },
    {
        period_start_month: 1746057600,
        document_type: "invoice",
        total_before_tax: 6953.47,
        vat_tax: 1363.81,
    },
    {
        period_start_month: 1748736000,
        document_type: "invoice",
        total_before_tax: 6427.69,
        vat_tax: 1261.87,
    },
    {
        period_start_month: 1751328000,
        document_type: "invoice",
        total_before_tax: 6728.37,
        vat_tax: 1566.76,
    },
    {
        period_start_month: 1754006400,
        document_type: "invoice",
        total_before_tax: 6729.83,
        vat_tax: 1315.28,
    },
    {
        period_start_month: 1756684800,
        document_type: "invoice",
        total_before_tax: 7151.32,
        vat_tax: 1337.94,
    },
    {
        period_start_month: 1759276800,
        document_type: "invoice",
        total_before_tax: 105727.99,
        vat_tax: 20396.57,
    },
    {
        period_start_month: 1761955200,
        document_type: "invoice",
        total_before_tax: 6946.57,
        vat_tax: 1366.76,
    },
    {
        period_start_month: 1764547200,
        document_type: "invoice",
        total_before_tax: 40614.54,
        vat_tax: 4099.7,
    },
];
